import { OptionsFactsheetsType } from "@/types/OptionType";

export const getFactsheetFromOptions = (
  key: string,
  factsheets: OptionsFactsheetsType,
) => {
  const pdf = factsheets.find((el) => el.name === key);
  if (pdf) return pdf;
  else return null;
};
